import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { RoleService } from '../../../../services/role.service';
import { AuthService, UserProfile } from '../../../../services/auth.service';
import { PeoplePickerService } from '../../../../shared/people-picker/people-picker-service';
import { DashboardService, ElDisplayDetail } from '../../../../services/dashboard/dashboard.service';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ProgramDescriptionPopup } from '../../program-description-popup/program-description-popup';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Pipe({ name: 'fuzzy', standalone: true })
export class FuzzyPipe implements PipeTransform {
  transform(list: string[] | null | undefined, term: string): string[] {
    if (!list) return [];
    if (!term || term.length < 3) return [];
    const lower = term.toLowerCase();
    return list.filter(x => (x || '').toLowerCase().includes(lower));
  }
}


@Pipe({ name: 'highlight', standalone: true })
export class HighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(value: string | undefined | null, term: string): SafeHtml {
    if (!value) return '';
    if (!term) return value;
    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp(escaped, 'gi');
    const html = value.replace(re, m => `<span class="highlightedText">${m}</span>`);
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}

@Component({
  selector: 'app-dashboard-header',
  imports: [CommonModule, FormsModule, NgbModule, RouterModule, FuzzyPipe, HighlightPipe],
  templateUrl: './dashboard-header.html',
  styleUrl: './dashboard-header.scss'
})
export class DashboardHeader implements OnInit {

  searchbox: any;
  isOPorELD: boolean = false;
  readonly nonProdEnvironmentLabel: string = this.getNonProdEnvironmentLabel();
  elImage: string | null = null;
  userFirstName: string | null = '';
  UserInitials: any;
  placeholderText: string = "Search for engagements, clients or acceptances by Name, ID, Opportunity ID";
  navbardata: any[] = [];
  contact = '';
  info = '';
  isOPLD = false; // original flag (typo in legacy?) kept
  isRiskCategoryDashboard = false;
  isQRSProgramFeatureEnabled: boolean = false;

  ProgramInfo: any[] = [];

  elDetails: any[] = [];
  elEngDetails: any[] = [];
  elDisplayDetails: ElDisplayDetail[] = [];

  elNameDetails: string[] = [];
  elNameDetailsBackup: string[] = [];

  cacheDetail = new Map<string, ElDisplayDetail>();
  showCrossmark: boolean = false;
  showDropdown: boolean = true;
  selectedResultIndex: number = -1;
  IsNoData: boolean = false;
  SearchresultsCount: number = 0;
  programDetails: any;

  get isProgramAdminDashboard(): boolean {
    const currentPath = this.router.url.split('?')[0].split('#')[0];
    return currentPath === '/dashboards/programadmindashboard'
      || currentPath === 'dashboards/programadmindashboard';
  }

  get isUserPopupAllowed(): boolean {
    const currentPath = this.router.url.split('?')[0].split('#')[0];
    return currentPath === '/dashboards/engagementleader'
      || currentPath === 'dashboards/engagementleader'
      || currentPath === '/dashboards/soleader'
      || currentPath === 'dashboards/soleader';
  }

  get isDashboardPage(): boolean {
    return this.router.url.includes('dashboards');
  }

  // get shouldShowRiskCategoriesButton(): boolean {
  //   return !this.isProgramAdminDashboard;
  // }

  get shouldShowSearchBox(): boolean {
    return this.isDashboardPage && !this.isProgramAdminDashboard;
  }

  private getNonProdEnvironmentLabel(): string {
    if (environment.production) {
      return '';
    }

    switch ((environment.envType || '').toUpperCase()) {
      case 'LOCAL':
        return 'Local-CI';
      case 'DEV':
        return 'Dev-CI';
      case 'QAS':
        return 'QA-CI';
      case 'STG':
        return 'Staging-CI';
      default:
        return '';
    }
  }

  goToHome() {

  }

  logout(): void {
    this.authService.logout();
  }

  openAuditDetails(): void {
    const url = this.router.serializeUrl(this.router.createUrlTree(['/admin/solleaderauditdetails']));
    window.open(url, '_blank');
  }
  constructor(public roleService: RoleService, private authService: AuthService, private peopleService: PeoplePickerService,
    private dashboardService: DashboardService, private modalService: NgbModal, private router: Router) {

  }
  ngOnInit(): void {
    // Ensure profile is fetched (not just cached) so UserInitials renders on all dashboards
    this.authService.fetchAndCacheUserProfile().subscribe();
    this.authService.getCachedUserProfile().subscribe((profile: UserProfile) => {
      this.userFirstName = profile?.givenName || '';
      this.UserInitials = this.userFirstName.charAt(0).toUpperCase() + (profile?.surname ? profile.surname.charAt(0).toUpperCase() : '');
      if (profile?.mail) {
        this.peopleService.getPhoto(profile?.mail || '').then(photo => {
          this.elImage = photo;
        });
      }
    });
    this.authService.fetchAndCacheRoles().subscribe(response => {
      const configsInfo = response?.ConfigsInfo;
      if (configsInfo && Array.isArray(configsInfo)) {
        const feature = configsInfo.find((c: any) => c.ConfigKey === 'ENABLE_QRS_PROGRAM_FEATURE');
        this.isQRSProgramFeatureEnabled = feature?.ConfigValue?.toUpperCase() === 'TRUE';
      }
    });
    this.wireEvents();
    this.getProgramDetails();
  }

  getProgramDetails() {
    this.dashboardService.getPrograms().subscribe(d => {
      this.programDetails = d;
    });
  }

  private wireEvents(): void {
    this.dashboardService.oplStaticData$.subscribe(data => {
      if (!data || !data.length) data = [{ ContactUs: 'No Data', Info: 'No Data' }];
      this.navbardata = data;
      this.contact = data[0]['ContactUs'];
      this.info = data[0]['Info'];
      this.isOPorELD = true;
      this.isOPLD = true;
      this.isRiskCategoryDashboard = !!data[0].isRiskCategoryDashboard;
    });

    this.dashboardService.elStaticData$.subscribe(data => {
      if (!data || !data.length) data = [{ ContactUs: 'No Data', Info: 'No Data' }];
      this.navbardata = data;
      this.contact = data[0]['ContactUs'];
      this.info = data[0]['Info'];
      this.isOPorELD = true;
      this.isOPLD = false;
    });

    this.dashboardService.elData$.subscribe(data => {
      this.resetElCollections();
      this.placeholderText = 'Search for engagement leaders, engagements, clients or acceptances by Name, ID, Opportunity ID';
      this.elDetails = data || [];
      const nameSet = new Set<string>();
      const display: ElDisplayDetail[] = [];

      for (const row of this.elDetails) {
        for (const x of row.searchData ?? []) {
          const pushIf = (val?: string) => {
            if (val != null && val !== '' && !nameSet.has(val)) nameSet.add(val);
          };
          pushIf(x.EngagementLeader);
          pushIf(x.ClientName);
          pushIf(x.DapId);
          pushIf(x.OpportunityId);
          pushIf(x.EngagementName);

          display.push({
            EngagementLeader: x.EngagementLeader,
            ClientName: x.ClientName,
            SolutionName: x.SolutionName,
            DapId: x.DapId,
            OpportunityId: x.OpportunityId,
            EngagementName: x.EngagementName,
            ProgramName: x.ProgramName
          });
        }
      }

      this.elNameDetails = Array.from(nameSet);
      this.elNameDetailsBackup = [...this.elNameDetails];
      this.elDisplayDetails = this.dashboardService.uniqueByValue(display);
    });

    this.dashboardService.elMasterData$.subscribe(data => {
      this.resetElCollections();
      this.placeholderText = 'Search for engagements, clients or acceptances by Name, ID, Opportunity ID';
      this.elEngDetails = data || [];
      const nameSet = new Set<string>();
      const display: ElDisplayDetail[] = [];

      for (const row of this.elEngDetails) {
        const pushIf = (val?: string) => {
          if (val != null && val !== '' && !nameSet.has(val)) nameSet.add(val);
        };
        const searchableFields = [row.EngagementName,
        row.ClientName,
        row.MercuryId,
        row.DapId
        ].filter(v => v != null && v !== '').join(' ');
        pushIf(searchableFields);
        display.push({
          EngagementName: row.EngagementName,
          ClientName: row.ClientName,
          MercuryId: row.MercuryId,
          DapId: row.DapId
        });
      }

      this.elNameDetails = Array.from(nameSet);
      this.elNameDetailsBackup = [...this.elNameDetails];
      this.elDisplayDetails = this.dashboardService.uniqueByValue(display);
    });

    this.dashboardService.periodFilterApply$.subscribe(msg => {
      if (msg === 'Refresh Searchbar') {
        this.searchbox = '';
        this.updateCrossmark();
      }
    });

    this.dashboardService.qrsSearchData$.subscribe(data => {
      this.resetElCollections();
      this.placeholderText = 'Search for engagements, clients or acceptances by Name, ID, Opportunity ID';
      this.isOPorELD = true;
      this.isOPLD = false;
      const nameSet = new Set<string>();
      const display: ElDisplayDetail[] = [];

      for (const row of (data || [])) {
        const pushIf = (val?: string) => {
          if (val != null && val !== '' && !nameSet.has(val)) nameSet.add(val);
        };
        const searchableFields = [row.EngagementName, row.ClientName, row.DapId]
          .filter(v => v != null && v !== '').join(' ');
        pushIf(searchableFields);
        display.push({
          EngagementName: row.EngagementName,
          ClientName: row.ClientName,
          DapId: row.DapId
        });
      }

      this.elNameDetails = Array.from(nameSet);
      this.elNameDetailsBackup = [...this.elNameDetails];
      this.elDisplayDetails = this.dashboardService.uniqueByValue(display);
    });

    // this.dashboardService.resetSearch$.subscribe(() => this.resetSearchBox());
  }
  private resetElCollections() {
    this.elDisplayDetails = [];
    this.elNameDetails = [];
    this.elNameDetailsBackup = [];
    this.cacheDetail.clear();
  }
  private updateCrossmark(): void {
    this.showCrossmark = !!this.searchbox && this.searchbox.length >= 1;
  }

  resetSearchBox(): void {
    this.searchbox = '';
    this.showDropdown = false;
    this.elNameDetails = [...this.elNameDetailsBackup];
    this.showCrossmark = false;
    this.selectedResultIndex = -1;
    this.dashboardService.emitSearch('');
    this.updateNoDataFlag();
  }


  private currentFiltered(): string[] {
    // Same condition as fuzzy pipe to know what is visible
    if (!this.searchbox || this.searchbox.length < 3 || !this.showDropdown) return [];
    const lower = this.searchbox.toLowerCase();
    return this.elNameDetails.filter(x => x.toLowerCase().includes(lower));
  }

  private updateNoDataFlag(): void {
    const visible = this.currentFiltered();
    this.IsNoData = this.searchbox.length >= 3 && visible.length === 0;
    this.SearchresultsCount = visible.length;
  }

  onResultKeydown(ev: KeyboardEvent, idx: number, name: string): void {
    if (ev.key === 'ArrowDown') {
      ev.preventDefault();
      const list = this.currentFiltered();
      this.selectedResultIndex = Math.min(list.length - 1, idx + 1);
    } else if (ev.key === 'ArrowUp') {
      ev.preventDefault();
      this.selectedResultIndex = idx === 0 ? -1 : idx - 1;
    } else if (ev.key === 'Enter') {
      ev.preventDefault();
      this.fillTextbox(name, ev);
    }
  }
  fillTextbox(name: string, keyEvent?: KeyboardEvent, clickEvent?: string): void {
    if ((keyEvent && keyEvent.key === 'Enter') || clickEvent === 'click') {
      this.searchbox = name;

      if (this.isOPLD) {
        // Map to EngagementLeader if necessary (legacy behavior)
        const found = this.elDisplayDetails.find(x =>
          x.ClientName === name ||
          x.OpportunityId === name ||
          x.DapId === name ||
          x.EngagementName === name ||
          x.EngagementLeader === name
        );
        if (found?.EngagementLeader) this.searchbox = found.EngagementLeader;
      }

      this.showDropdown = false;
      this.dashboardService.emitSearch(this.searchbox, true);
      this.showCrossmark = true;
      this.selectedResultIndex = -1;
    }
  }
  getDetails(name: string): ElDisplayDetail | undefined {
    if (this.cacheDetail.has(name)) return this.cacheDetail.get(name);
    // Mirror original matching logic
    let match: ElDisplayDetail | undefined;
    if (this.isOPLD) {
      match = this.elDisplayDetails.find(z =>
        z.EngagementLeader === name ||
        z.ClientName === name ||
        z.SolutionName === name ||
        z.DapId === name ||
        z.OpportunityId === name ||
        z.EngagementName === name
      );
    } else {
      match = this.elDisplayDetails.find(z => {
        const combinedString = [z.EngagementName, z.ClientName, z.MercuryId, z.DapId]
          .filter(v => v != null && v !== '')
          .join(' ')
          .toLowerCase();
        return combinedString.includes(name.toLowerCase());
      });
    }
    if (match) this.cacheDetail.set(name, match);
    return match;
  }
  onSearchKeyup(ev: KeyboardEvent): void {
    const term = this.searchbox;
    this.showDropdown = true;

    if (ev.key === 'Enter') {
      if (term) {
        this.showDropdown = false;
        this.dashboardService.emitSearch(term);
      }
    } else if (ev.key === 'ArrowDown') {
      const list = this.currentFiltered();
      if (list.length) {
        this.selectedResultIndex = 0;
      }
    } else if (ev.key === 'ArrowUp') {
      this.selectedResultIndex = Math.max(-1, this.selectedResultIndex - 1);
    }

    if (!term) {
      this.showDropdown = false;
      this.showCrossmark = false;
      this.dashboardService.emitSearch('');
    }
    this.updateCrossmark();
    this.updateNoDataFlag();
  }

  get canShowAuditTrail(): boolean {
    return (this.roleService.isInRole('Program Admin') || this.roleService.isInRole('LER') || this.roleService.isInRole('Quality Champ'))
      && (
        this.router.url.includes('programadmindashboard') ||
        (this.router.url.includes('engagementdetails') && this.dashboardService.selectedEngagement()?.qmtId != null)
      )
  }
  openAuditTrail(): void {
    let url: string;
    if (this.router.url.includes('programadmindashboard')) {
      url = this.router.serializeUrl(
        this.router.createUrlTree(['/program-audit-trail'])
      );
    }
    else {
      const engagementId = this.dashboardService.selectedEngagement()?.engagementId;
      console.log('Selected Engagement ID:', engagementId);
      url = this.router.serializeUrl(
        this.router.createUrlTree(['/audit-trail/', engagementId])
      );
    }
    window.open(url, '_blank');
  }
}
